import { render, staticRenderFns } from "./PhoneCartegory.vue?vue&type=template&id=01b731f0&scoped=true&"
import script from "./PhoneCartegory.vue?vue&type=script&lang=js&"
export * from "./PhoneCartegory.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCartegory.vue?vue&type=style&index=0&id=01b731f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b731f0",
  null
  
)

component.options.__file = "PhoneCartegory.vue"
export default component.exports